import MagicLinkExpired from '../../components/login/MagicLinkExpired';

const MagicLinkExpiredPortal = (props) => (
  <MagicLinkExpired {...props} />
);

export default MagicLinkExpiredPortal;
